import { c as _c } from "react/compiler-runtime";
import { graphql, useClient } from "@opensea/graphql";
import { useFileUpload } from "./api/use-file-upload";
const useDropMediaUploadMutation = graphql(`
  mutation useDropMediaUploadMutation(
    $collectionSlug: String!
    $filenames: [String!]!
  ) {
    uploadDropItemMedia(
      collectionSlug: $collectionSlug
      filenames: $filenames
    ) {
      url
      method
      fields
      token
    }
  }
`);
export function useDropMediaUpload(collectionSlug, setState) {
  const $ = _c(6);
  const client = useClient();
  let t0;
  if ($[0] !== client || $[1] !== collectionSlug) {
    t0 = async files => {
      const filenames = files.map(_temp);
      const response = await client.mutation(useDropMediaUploadMutation, {
        collectionSlug,
        filenames
      }).toPromise();
      if (response.error) {
        throw response.error;
      }
      return response.data?.uploadDropItemMedia ?? [];
    };
    $[0] = client;
    $[1] = collectionSlug;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== setState || $[4] !== t0) {
    t1 = {
      setState,
      getContext: t0
    };
    $[3] = setState;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return useFileUpload(t1);
}
function _temp(file) {
  return file.name;
}